import script from "./AFSignatureComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AFSignatureComponent.vue?vue&type=script&setup=true&lang=js"

import "./AFSignatureComponent.vue?vue&type=style&index=0&id=3c5107c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5107c2"]])

export default __exports__